/**
 * サブスクリプション契約のコンテスト表現.
 *
 * 単発の注文ではなく、一度の契約で繰り返し商品を受け取るような
 * サブスクリプション契約を申し込む場合に利用する.
 *
 * @see {OnceOrderContext} 単発の注文において利用されるコンテキスト.
 */
import { CartItem } from '@/models/cart/cart-item'
import { CreditcardServiceForSubscription } from '@/services/api/subscription/payment/creditcard-service-for-subscription'
import { OrderContext } from '@spa/components/pages/order/model/context/order-context'

interface ContextDependencies {
  skuId: string
}

export class SubscriptionContext implements OrderContext {
  static build(deps: ContextDependencies): OrderContext {
    return new SubscriptionContext(deps)
  }

  private constructor(
    private readonly deps: ContextDependencies
  ) {}

  get title(): string {
    return 'お申込内容の確認'
  }

  get path() {
    const root = `/order/subscription/${this.deps.skuId}`

    return {
      confirmPage: root,

      editPayment: `${root}/edit/payment`,
      addCreditCard: `${root}/edit/payment/new-creditcard`,

      editContact: `${root}/edit/contact`,
      addContact: `${root}/edit/new-contact`,

      completeProfile: `${root}/complete-profile`,

      orderComplete: `${root}/complete`,
    }
  }

  get filter() {
    return {
      cartItems: (items: CartItem[]): CartItem[] => items.filter(i => i.skuId === this.deps.skuId),
    }
  }

  get factory() {
    return {
      service: {
        creditCard() {
          return new CreditcardServiceForSubscription()
        },
      },
    }
  }
}
